import { ThermometerSun } from "lucide-react";
import { site } from "../content";
import { Reveal, SectionHeading } from "./Reveal";

export default function HowItWorks() {
  return (
    <section id="como-funciona" data-testid="how-it-works-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading
          chapter="02"
          eyebrow="Como funciona"
          title="Simples para o barbeiro. Marcante para o cliente."
          testId="how-it-works-heading"
        />

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {site.steps.map((step, i) => (
            <Reveal key={step.number} delay={i * 0.12}>
              <div
                data-testid={`step-card-${step.number}`}
                className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-graphite/60 p-8 backdrop-blur-xl transition-[border-color] duration-500 hover:border-gold/40"
              >
                <span
                  className="pointer-events-none absolute -right-3 -top-7 font-serif text-[120px] italic leading-none text-white/[0.05] transition-colors duration-500 group-hover:text-gold/10"
                  aria-hidden="true"
                >
                  {step.number}
                </span>
                <p className="font-display text-xs font-bold tracking-[0.4em] text-gold">
                  {step.number}
                </p>
                <h3 className="mt-5 font-display text-xl font-extrabold uppercase tracking-wide text-bone">
                  {step.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-bone/55">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div
            data-testid="steps-note"
            className="mt-10 flex items-center gap-4 rounded-2xl border border-gold/25 bg-gold/[0.06] px-6 py-5 backdrop-blur-md"
          >
            <ThermometerSun className="h-6 w-6 shrink-0 text-gold" aria-hidden="true" />
            <p className="text-sm font-medium text-bone/85 md:text-base">{site.stepsNote}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
